import React, { useState } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { CONTACT, ASSETS } from './Constants';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Tratamiento',
    href: '#tratamiento'
  }, {
    name: 'Sedes',
    href: '#sedes'
  }, {
    name: 'Profesionales',
    href: '#profesionales'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className="bg-white sticky top-0 z-50 shadow-sm" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <div className="flex justify-between items-center h-20" data-id="element-113">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-114">
            <a href="#inicio" data-id="element-115">
              <img className="h-12 w-auto object-contain" src={ASSETS.logo} alt="Evolución Chile Centros de Rehabilitación" data-id="element-116" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-117">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-600 hover:text-azul font-medium text-sm transition-colors" data-id="element-118">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center" data-id="element-119">
            <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-2.5 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-whatsapp hover:bg-whatsapp-hover transition-colors" data-id="element-120">
              <MessageCircle className="w-4 h-4 mr-2" data-id="element-121" />
              Hablar por WhatsApp
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden space-x-4" data-id="element-122">
            <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center p-2 rounded-full text-whatsapp bg-green-50 hover:bg-green-100 transition-colors" aria-label="Hablar por WhatsApp" data-id="element-123">
              <MessageCircle className="w-5 h-5" data-id="element-124" />
            </a>
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-125">
              <span className="sr-only" data-id="element-126">Abrir menú principal</span>
              {isMenuOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-127" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-128" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100" data-id="element-129">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-130">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-azul hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-131">
                {link.name}
              </a>)}
            <div className="pt-4 pb-2 px-3" data-id="element-132">
              <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center px-4 py-3 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-whatsapp hover:bg-whatsapp-hover" data-id="element-133">
                <MessageCircle className="w-5 h-5 mr-2" data-id="element-134" />
                Hablar por WhatsApp
              </a>
            </div>
          </div>
        </div>}
    </header>;
}